import isDecimalAmount from "../validations/is.decimal.amount";

export default (values, value) => isDecimalAmount(value);
